import {TextField} from "@material-ui/core";
import React, {useState} from "react";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import FormControl from "@material-ui/core/FormControl";
import {makeStyles} from "@material-ui/core/styles";
import {useTranslation} from "react-i18next";

const useStyles = makeStyles(theme => ({
    inputSection: {
        marginBottom: '15px',
        [theme.breakpoints.down('sm')]: {
            flexWrap: 'wrap'
        },
        [theme.breakpoints.up('md')]: {
            flexWrap: 'nowrap%'
        }
    },
    inputField: {
        [theme.breakpoints.down('sm')]: {
            width: '100%'
        },
        [theme.breakpoints.up('md')]: {
            width: '45%'
        }
    }
}));

export const MachineAddNewTagForm = ({
                                         handleNewTagAdd
                                     }: any) => {
    const [name, setName] = useState<string>();
    const [value, setValue] = useState<string>();
    const classes = useStyles();
    const {t} = useTranslation();

    const handleTextInput = (setFn: any) => ($event: any) => {
        setFn($event.target.value);
    };

    const clearInput = () => {
        setName('');
        setValue('');
    }

    return (
        <Grid container direction="column" justify="space-between" alignContent="stretch">
            <FormControl>
                <Grid container className={classes.inputSection} direction="row" justify="space-between"
                      alignItems="center">
                    <TextField className={classes.inputField} label={t('_Common.Labels.Name')}
                               id="tag-name"
                               value={name}
                               onChange={handleTextInput(setName)}/>
                    <TextField className={classes.inputField} label={t('_Common.Labels.Value')}
                               id="tag-value"
                               value={value}
                               onChange={handleTextInput(setValue)}/>
                </Grid>
            </FormControl>
            <Grid container direction="row" justify="flex-end" alignItems="center">
                <Button variant="text"
                        color="primary"
                        disabled={!name || !value}
                        onClick={() => {
                            clearInput();
                            handleNewTagAdd({key: name, value});
                        }}>
                    {t('Machine.Actions.AddTag')}
                </Button>
            </Grid>
        </Grid>
    );
}
